import { render, staticRenderFns } from "./DialogAttachRFQ2.vue?vue&type=template&id=1fde88b3&"
import script from "./DialogAttachRFQ2.vue?vue&type=script&lang=js&"
export * from "./DialogAttachRFQ2.vue?vue&type=script&lang=js&"
import style0 from "./DialogAttachRFQ2.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports